import React from "react";
import { Button } from "react-bootstrap";
import videoThumb from "../../../../Assets/images/pdf_thumbnail.png";

const Thumbnail = ({ tutorial, onClick }) => {
  const handleClick = () => {
    onClick(tutorial.media, tutorial.media_type);
  };

  if (tutorial.media_type === "video") {
    return (
      <Button variant="link" className="p-0 border-0" onClick={handleClick}>
        <video src={tutorial?.media} width="70" height="70"></video>
      </Button>
    );
  } else if (tutorial.media_type === "pdf") {
    return (
      <a href={tutorial?.media} target="_blank" rel="noreferrer">
        <img
          src={videoThumb}
          alt="PDF Thumbnail"
          className="img-fluid"
          style={{
            maxWidth: "70px",
            maxHeight: "70px",
            objectFit: "cover",
          }}
        />
      </a>
    );
  } else {
    return (
      <img
        src={videoThumb}
        alt="Thumbnail"
        className="img-fluid"
        style={{
          maxWidth: "70px",
          maxHeight: "70px",
          objectFit: "cover",
        }}
      />
    );
  }
};

export default Thumbnail;
